import ReplyAll from '@mui/icons-material/ReplyAll';
import Style from '@mui/icons-material/Style';
import Undo from '@mui/icons-material/Undo';
import Warning from '@mui/icons-material/Warning';
import { IconButton, List, ListItem, Popover, Skeleton, Stack, Tooltip, Typography } from '@mui/material';
import { MEIO_JULGAMENTO_PROCESSO } from '@/dominio/MeioJulgamentoProcesso';
import SituacaoJulgamentoProcessoBusiness from '@/dominio/SituacaoJulgamentoProcessoBusiness';
import { TIPO_REMESSA_JULGAMENTO_PROCESSO } from '@/dominio/TipoRemessaJulgamentoProcesso';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import Configuracao from '@/util/Configuracao';
import DataUtil from '@/util/DataUtil';
import StringUtil from '@/util/StringUtil';
import ReactComponent from '../ReactComponent';
import ModalConfirmacao from './ModalConfirmacao';
import IconeTipoRemessaJulgamentoFormRemessa from './icones/IconeTipoRemessaJulgamentoFormRemessa';
import AlterarSituacaoJulgamento from './AlterarSituacaoJulgamento';
import ResultadoJulgamento from './ResultadoJulgamento';
import { RESULTADO_JULGAMENTO } from '@/dominio/ResultadoJulgamento';

class PainelJulgamento extends ReactComponent {
    abrirConfirmacaoDesfazimentoApreciacao = false;
    openCadastroRemessa = false;
    anchorEl = null;
    tipoRemessaPadrao = TIPO_REMESSA_JULGAMENTO_PROCESSO.RFP;
    openDialogAlterarSituacaoJulgamento = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            abrirConfirmacaoDesfazimentoApreciacao: observable,
            openCadastroRemessa: observable,
            anchorEl: observable,
            tipoRemessaPadrao: observable,
            openDialogAlterarSituacaoJulgamento: observable,
            registro: computed,
            isCarregando: computed,
            codigoMeioJulgamentoProcesso: computed,
            remessaJulgamento: computed,
            isProcessoRemetido: computed,
            prazos: computed,
            sessaoSelecionada: computed,
            isSessaoExclusivamenteVirtual: computed,
            codigoMeioJulgamentoSessao: computed,
            isEmJulgamentoVirtual: computed,
            isJulgamentoVirtualEmAndamento: computed,
            isJaPassouDataSessaoPresencial: computed,
            isJaPassouPeriodoJulgamentoVirtual: computed,
            loteProcessos: computed,
            idPopoverCadastroRemessa: computed,
            handleCloseRemessa: action,
            handleClickDesfazer: action,
            cancelarDesfazerApreciacao: action,
            desfazerApreciacaoJulgamento: action,
            alterarResultadoJulgamento: action,
            handleClickDesfazerTodos: action,
            removerVistaRegimental: action,
            desfazerApreciacaoDeTodosOsProcessos: action,
            handleClickTestarAlteracaoMinuta: action,
            desabilitarDesfazerApreciacaoPJe: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get isCarregando() {
        if (
            this.store.processoExpandido?.processo?.numeroCompleto &&
            this.store.processoExpandido.processo.numeroCompleto === this.registro?.processo?.numeroCompleto
        ) {
            const carregandoDetalhesProcesso = this.store.carregandoDetalhesProcesso.get(
                this.store.getChaveControleCarregamentoDetalhes(this.registro)
            );

            return !!(
                carregandoDetalhesProcesso?.carregando ||
                this.store.carregandoProcessos ||
                this.store.carregandoSessao
            );
        }

        return false;
    }

    get codigoMeioJulgamentoProcesso() {
        return this.registro?.tipoJulgamento;
    }

    get remessaJulgamento() {
        return this.registro?.remessaJulgamento;
    }

    get isProcessoRemetido() {
        return SituacaoJulgamentoProcessoBusiness.isProcessoRemetido(
            this.codigoMeioJulgamentoProcesso,
            this.remessaJulgamento
        );
    }

    get prazos() {
        return this.observableProps.stores.sessaoStore.sessaoSelecionada.prazos;
    }

    get sessaoSelecionada() {
        return this.sessaoStore.sessaoSelecionada;
    }

    get isSessaoExclusivamenteVirtual() {
        return SituacaoJulgamentoProcessoBusiness.isProcessoPautadoEmJulgamentoExclusivamenteVirtual(
            this.sessaoStore.sessaoSelecionada.tipoJulgamento
        );
    }

    get codigoMeioJulgamentoSessao() {
        if (this.sessaoSelecionada?.tipoJulgamento) {
            return this.sessaoSelecionada?.tipoJulgamento;
        }

        return '';
    }

    get isEmJulgamentoVirtual() {
        if (!this.registro?.tipoJulgamento) {
            console.error('Registro sem tipo de julgamento!');
            return false;
        }

        return SituacaoJulgamentoProcessoBusiness.isProcessoEmJulgamentoVirtual(
            this.registro.tipoJulgamento,
            this.registro.remessaJulgamento
        );
    }

    get isJulgamentoVirtualEmAndamento() {
        if (!this.isEmJulgamentoVirtual) {
            return false;
        }

        if (
            !this.prazos?.dataInicioVotacaoVirtual ||
            (!this.sessaoStore?.sessaoSelecionada?.prazos?.dataFimVotacaoVirtualExibicao &&
                !this.sessaoStore?.sessaoSelecionada?.prazos?.dataFimVotacaoVirtual)
        ) {
            console.error('Votação virtual sem datas de início e fim!');
            return false;
        }

        const dataInicioVirtual = this.sessaoStore.sessaoSelecionada.prazos.dataInicioVotacaoVirtual;

        const dataFimVirtual =
            this.sessaoStore?.sessaoSelecionada?.prazos?.dataFimVotacaoVirtualExibicao ||
            this.sessaoStore?.sessaoSelecionada?.prazos?.dataFimVotacaoVirtual;

        return DataUtil.isDataExataJaPassou(dataInicioVirtual) && !DataUtil.isDataExataJaPassou(dataFimVirtual);
    }

    get isJaPassouDataSessaoPresencial() {
        if (!this.sessaoStore?.sessaoSelecionada?.prazos?.dataInicioSessaoPresencial) {
            return false;
        }

        return DataUtil.isDiaJaPassou(this.sessaoStore.sessaoSelecionada.prazos.dataInicioSessaoPresencial);
    }

    get isJaPassouPeriodoJulgamentoVirtual() {
        if (
            !this.sessaoStore?.sessaoSelecionada?.prazos?.dataFimVotacaoVirtualExibicao &&
            !this.sessaoStore?.sessaoSelecionada?.prazos?.dataFimVotacaoVirtual
        ) {
            return false;
        }

        const dataFimVirtual =
            this.sessaoStore?.sessaoSelecionada?.prazos?.dataFimVotacaoVirtualExibicao ||
            this.sessaoStore?.sessaoSelecionada?.prazos?.dataFimVotacaoVirtual;

        return DataUtil.isDataExataJaPassou(dataFimVirtual);
    }

    get loteProcessos() {
        return this.observableProps.loteProcessos || [];
    }

    get idPopoverCadastroRemessa() {
        return this.openCadastroRemessa ? 'popover-remessa-desfazimento-julgamento' : undefined;
    }

    handleCloseRemessa = () => {
        this.openCadastroRemessa = false;
        this.anchorEl = null;
    };

    handleClickDesfazer = async () => {
        if (!this.isEmJulgamentoVirtual || this.isJulgamentoVirtualEmAndamento) {
            await this.desfazerApreciacao();
        } else {
            this.abrirConfirmacaoDesfazimentoApreciacao = true;
        }
    };

    cancelarDesfazerApreciacao = () => {
        this.abrirConfirmacaoDesfazimentoApreciacao = false;
    };

    desfazerApreciacaoJulgamento = async () => {
        let sucesso = await this.desfazerApreciacao();
        const msgPadrao = `Apreciação desfeita [${this.registro?.processo?.numeroCompleto}].`;

        if (sucesso) {
            if (!this.isSessaoExclusivamenteVirtual) {
                if (this.isProcessoRemetido) {
                    this.mensagemStore.abrirMensagemSucesso(msgPadrao);
                } else {
                    await this.remeterParaPresencialVinculada();
                    this.mensagemStore.abrirMensagemSucesso(
                        `Apreciação desfeita e processo remetido para sessão presencial vinculada [${this.registro?.processo?.numeroCompleto}].`
                    );
                }
            } else if (this.isProcessoRemetido) {
                this.mensagemStore.abrirMensagemSucesso(msgPadrao);
                // TODO Permitir alterar o tipo de remessa para sessão futura
            } else {
                this.mensagemStore.abrirMensagemSucesso(msgPadrao);

                /*
                // TODO Selecionar o tipo de remessa para sessão futura
                this.mensagemStore.abrirMensagemSucesso('Apreciação desfeita. Selecione o tipo de remessa.');
                runInAction(() => {
                    this.openCadastroRemessa = true;
                    this.tipoRemessaPadrao = TIPO_REMESSA_JULGAMENTO_PROCESSO.RFP;
                });
                */
            }
        }
    };

    async remeterParaPresencialVinculada() {
        await this.processoService.alterarTipoJulgamento(
            this.registro,
            MEIO_JULGAMENTO_PROCESSO.REMETIDO_PARA_SESSAO_VINCULADA.codigo
        );
        await this.atualizarRascunhoCertidaoRemetidoPresencial();
        this.salaSessaoStore.recarregarProcesso(this.registro);
    }

    async atualizarRascunhoCertidaoRemetidoPresencial() {
        let texto =
            'processo julgado virtualmente, remetido para apreciação em sessão presencial, com chamamento do feito à ordem.';
        let rascunho = await this.certidaoService.recuperarRascunhoCertidao(this.registro);

        if (rascunho.indexOf(texto) === -1) {
            rascunho += '\n\n' + texto;
            await this.certidaoService.salvarRascunhoCertidao(this.registro, rascunho);
            runInAction(() => (this.registro.rascunhoCertidao = rascunho));
        }
    }

    async desfazerApreciacao() {
        const vistas = this.registro.resultadoJulgamento?.codigo === RESULTADO_JULGAMENTO.VISTA_REGIMENTAL.codigo
            ? this.registro.informacoesAdicionais.VistaRegimental
            : undefined;

        let sucesso = await this.alterarResultadoJulgamento(vistas);
        if (sucesso) {
            runInAction(() => {
                this.registro.liberadoParaGabinete = false;
                if (vistas) {
                    this.registro.informacoesAdicionais.VistaRegimental = undefined;
                }
            });
        }

        return sucesso;
    }

    alterarResultadoJulgamento = async (vistas) => {
        let tipoResultadoJulgamento = this.salaSessaoStore.getTipoResultadoJulgamento(
            RESULTADO_JULGAMENTO.NAO_JULGADO.codigo
        );
        let sucesso = await this.salaSessaoStore.julgar(this.registro, tipoResultadoJulgamento, vistas);

        if (sucesso) {
            this.mensagemStore.abrirMensagemSucesso(
                'Apreciação desfeita (' + this.registro.processo.numeroCompleto + ')'
            );
        } else {
            this.mensagemStore.abrirMensagemErro(
                'Não foi possível desfazer a apreciação do processo ' + this.registro.processo.numeroCompleto
            );
        }

        return sucesso;
    };

    handleClickDesfazerTodos = () => {
        this.desfazerApreciacaoDeTodosOsProcessos();
    };

    removerVistaRegimental = async () => {
        await this.processoService.removerVistaRegimental(this.registro);
        runInAction(() => (this.registro.informacoesAdicionais.VistaRegimental = undefined));
    };

    desfazerApreciacaoDeTodosOsProcessos = async () => {
        this.sessaoStore.carregandoProcessos = true;

        await this.salaSessaoStore.julgarProcessos(
            this.salaSessaoStore.processosApreciados,
            this.salaSessaoStore.getTipoResultadoJulgamento(RESULTADO_JULGAMENTO.NAO_JULGADO.codigo)
        );

        this.salaSessaoStore.recarregarListaProcessos();
    };

    handleClickTestarAlteracaoMinuta = () => {
        if (this.registro) {
            this.sessaoService.testarAlteracaoMinuta(this.registro.sessaoId, this.registro.processo.numeroCompleto);
        }
    };

    get desabilitarDesfazerApreciacaoPJe() {
        return (
            this.registro &&
            this.salaSessaoStore.isProcessoApreciado(this.registro) &&
            (this.registro.certidaoJulgamentoTransferida || this.registro.movimentosTransferidos)
        );
    }

    getPluralMensagemTooltip(mensagens) {
        return mensagens && mensagens.length > 1 ? 's' : '';
    }

    renderLoading() {
        const tamanhoButtonIconSkeleton = 40;

        if (this.salaSessaoStore.isProcessoApreciado(this.registro)) {
            return (
                <Skeleton
                    variant="rounded"
                    width={tamanhoButtonIconSkeleton}
                    height={tamanhoButtonIconSkeleton}
                />
            );
        }

        return (
            <Stack
                direction={'row'}
                spacing={1}
            >
                <Skeleton
                    variant="rounded"
                    width={tamanhoButtonIconSkeleton}
                    height={tamanhoButtonIconSkeleton}
                />
                <Skeleton
                    variant="rounded"
                    width={tamanhoButtonIconSkeleton}
                    height={tamanhoButtonIconSkeleton}
                />
                <Skeleton
                    variant="rounded"
                    width={tamanhoButtonIconSkeleton}
                    height={tamanhoButtonIconSkeleton}
                />
                <Skeleton
                    variant="rounded"
                    width={tamanhoButtonIconSkeleton}
                    height={tamanhoButtonIconSkeleton}
                />
            </Stack>
        );
    }

    renderAlertaMotivosQueImpedemApreciarOuDesfazerApreciacao(mensagens) {
        const tooltip = (
            <>
                <Typography>
                    O processo não pode
                    {!this.salaSessaoStore.isProcessoApreciado(this.registro)
                        ? ' ser apreciado'
                        : ' ter sua apreciação desfeita'}
                    {mensagens.length > 1 ? ' pelos seguintes motivos:' : ' pelo seguinte motivo:'}
                </Typography>
                <List dense={true}>
                    {mensagens.map((mensagem) => {
                        return (
                            <ListItem key={StringUtil.fnv1a32(mensagem)}>
                                <Typography>&bull;</Typography>
                                <Typography
                                    display={'inline'}
                                    sx={{ ml: 1.5 }}
                                >
                                    {mensagem}
                                </Typography>
                            </ListItem>
                        );
                    })}
                </List>
            </>
        );

        return (
            <Tooltip title={tooltip}>
                <Warning style={{ fill: 'darkorange', marginRight: '5px' }} />
            </Tooltip>
        );
    }

    render() {
        if (this.isCarregando) {
            return this.renderLoading();
        }

        let impeditivoParaAlterar = false;
        let mensagens = [];

        if (this.registro?.necessitaImportacaoSalaSessao) {
            impeditivoParaAlterar = true;
            mensagens.push('Processo não importado para sala de sessão.');
        }

        if (
            this.registro &&
            this.registro.processo?.origem === Configuracao.ORIGEM_PJE &&
            !this.salaSessaoStore.isPermitidaApreciacaoProcesso(this.registro)
        ) {
            mensagens.push(
                'Apenas sessões com situação "INICIADA" ou "EM PLENÁRIO VIRTUAL" permitem apreciação de processos.'
            );
        }

        if (this.desabilitarDesfazerApreciacaoPJe) {
            impeditivoParaAlterar = true;
            mensagens.push('Não é possível desfazer apreciação. O processo já foi enviado ao PJe.');
        }

        if (this.registro?.acordaoPublicado) {
            impeditivoParaAlterar = true;
            mensagens.push('Não é possível desfazer apreciação de processos com acórdão já enviado para publicação.');
        }

        if (this.registro?.certidaoJulgamentoAssinada) {
            impeditivoParaAlterar = true;
            mensagens.push('Não é possível desfazer apreciação de processos com certidão de julgamento assinada.');
        }

        if (this.registro?.movimentosTransferidos) {
            impeditivoParaAlterar = true;
            mensagens.push('Não é possível desfazer apreciação de processos com movimentos transferidos.');
        }

        if (this.salaSessaoStore.isProcessoApreciado(this.registro)) {
            if (this.isSessaoExclusivamenteVirtual) {
                if (Configuracao.EXIBIR_RESULTADO_JULGAMENTO_ANTES_DO_FIM_DO_PERIODO_VIRTUAL_PARA_O_PUBLICO_EXTERNO) {
                    mensagens.push(
                        'Não é possível desfazer apreciação de processos em julgamento exclusivamente virtual.'
                    );
                } else if (this.isJaPassouPeriodoJulgamentoVirtual) {
                    mensagens.push(
                        'Não é possível desfazer apreciação de processos virtuais após o período de julgamento virtual.'
                    );
                }
            } else if (this.isEmJulgamentoVirtual) {
                if (Configuracao.EXIBIR_RESULTADO_JULGAMENTO_ANTES_DO_FIM_DO_PERIODO_VIRTUAL_PARA_O_PUBLICO_EXTERNO) {
                    mensagens.push('Não é possível desfazer apreciação de processos em julgamento virtual.');
                } else if (this.isJaPassouDataSessaoPresencial) {
                    mensagens.push(
                        'Não é possível desfazer apreciação de processos virtuais após a data de realização da sessão presencial vinculada.'
                    );
                }
            }
        }

        if (mensagens.length > 0) {
            return (
                <>
                    {this.renderAlertaMotivosQueImpedemApreciarOuDesfazerApreciacao(mensagens)}
                    {!impeditivoParaAlterar && (
                        <IconButton>
                            <ResultadoJulgamento
                                registro={this.registro}
                                permitirAlterarSituacao={true}
                            />
                        </IconButton>
                    )}
                    {this.renderDesfazerApreciacaoTodosProcessos()}
                    {this.renderSimularAlteracaoMinutaEmAmbienteDev()}
                </>
            );
        }

        if (!this.salaSessaoStore.isProcessoApreciado(this.registro) || this.loteProcessos.length > 0) {
            return (
                <>
                    <AlterarSituacaoJulgamento
                        registro={this.registro}
                        loteProcessos={this.loteProcessos}
                    />
                    {this.renderDesfazerApreciacaoTodosProcessos()}
                    {this.renderSimularAlteracaoMinutaEmAmbienteDev()}
                </>
            );
        }

        return (
            <div style={{ display: 'flex' }}>
                {
                    <IconButton
                        onClick={this.handleClickDesfazer}
                        style={{ padding: '8px' }}
                        size="large"
                    >
                        <Tooltip
                            placement="top"
                            title={<Typography>Desfazer apreciação</Typography>}
                        >
                            <Undo style={{ fill: '#000000' }} />
                        </Tooltip>
                    </IconButton>
                }
                <IconButton>
                    <ResultadoJulgamento
                        registro={this.registro}
                        permitirAlterarSituacao={true}
                    />
                </IconButton>
                {this.renderDesfazerApreciacaoTodosProcessos()}
                {this.renderSimularAlteracaoMinutaEmAmbienteDev()}
                {this.registro && (this.isSessaoExclusivamenteVirtual || this.isEmJulgamentoVirtual) && (
                    <ModalConfirmacao
                        titulo={'Desfazer apreciação'}
                        open={this.abrirConfirmacaoDesfazimentoApreciacao}
                        callbackCancelar={this.cancelarDesfazerApreciacao}
                        callbackConfirmar={this.desfazerApreciacaoJulgamento}
                    >
                        <Typography display={'inline'}>Atenção! O processo </Typography>
                        <Typography
                            display={'inline'}
                            fontWeight={'bold'}
                        >
                            {this.registro.processo.numeroCompleto + ' '}
                        </Typography>
                        <Typography display={'inline'}>já consta como apreciado em sessão virtual. </Typography>
                        <Typography display={'inline'}>
                            {this.isSessaoExclusivamenteVirtual
                                ? 'Para o desfazimento da apreciação será necessário o chamamento do feito à ordem registrado em certidão de julgamento.'
                                : 'O desfazimento da apreciação irá remeter o processo para sessão presencial, com o chamamento do feito à ordem na sessão presencial vinculada.'}
                        </Typography>
                    </ModalConfirmacao>
                )}
                {this.registro && this.openCadastroRemessa && (
                    <Popover
                        id={this.idPopoverCadastroRemessa}
                        open={this.openCadastroRemessa}
                        anchorEl={this.anchorEl}
                        onClose={this.handleCloseRemessa}
                        sx={{
                            maxWidth: 'xl'
                        }}
                    >
                        <IconeTipoRemessaJulgamentoFormRemessa
                            registro={this.registro}
                            tipoRemessaPadrao={this.tipoRemessaPadrao}
                            onClose={this.handleCloseRemessa}
                        />
                    </Popover>
                )}
            </div>
        );
    }

    renderDesfazerApreciacaoTodosProcessos() {
        if (
            !this.isComponenteHabilitado('DESENVOLVIMENTO') ||
            !this.parametroStore.isOrgaoTST ||
            !this.salaSessaoStore.isProcessoApreciado(this.registro)
        ) {
            return null;
        }

        return (
            <IconButton
                onClick={this.handleClickDesfazerTodos}
                style={{ padding: '8px' }}
                size="large"
            >
                <Tooltip
                    placement="top"
                    title="Desfazer apreciação de todos os processos (dev-only)"
                >
                    <ReplyAll style={{ fill: '#000000' }} />
                </Tooltip>
            </IconButton>
        );
    }

    renderSimularAlteracaoMinutaEmAmbienteDev() {
        if (!this.isComponenteHabilitado('DESENVOLVIMENTO') || !this.parametroStore.isOrgaoTST) {
            return null;
        }

        return (
            <IconButton
                onClick={this.handleClickTestarAlteracaoMinuta}
                style={{ padding: '8px' }}
                size="large"
            >
                <Tooltip
                    placement="top"
                    title="Testar alteração minuta (dev-only)"
                >
                    <Style style={{ fill: '#000000' }} />
                </Tooltip>
            </IconButton>
        );
    }
}

export default inject('stores')(observer(PainelJulgamento));
